import { render, staticRenderFns } from "./reset-password-view.vue?vue&type=template&id=babf8768&scoped=true&"
import script from "./reset-password-view.vue?vue&type=script&lang=js&"
export * from "./reset-password-view.vue?vue&type=script&lang=js&"
import style0 from "./reset-password-view.vue?vue&type=style&index=0&id=babf8768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babf8768",
  null
  
)

export default component.exports